//@ts-nocheck
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { INITIAL_STATE } from './constants'
import { createBuilderSlice } from './slices/builderSlice'
import { createDealerFitsSlice } from './slices/dealerFitsSlice'
import { createFactoryFitsSlice } from './slices/factoryFitsSlice'
import { createServiceContractSlice } from './slices/serviceContractSlice'
import { createTransportSlice } from './slices/transportSlice'
import { createUiSlice } from './slices/uiSlice'
import { createWarrantySlice } from './slices/warrantySlice'
import type { EquipmentStore } from './types'

export const useEquipmentStore = create<EquipmentStore>()(
  devtools(
    persist(
      (set, get) => ({
        ...INITIAL_STATE,
        ...createBuilderSlice(set, get),
        ...createFactoryFitsSlice(set, get),
        ...createDealerFitsSlice(set, get),
        ...createWarrantySlice(set, get),
        ...createUiSlice(set, get),
        ...createTransportSlice(set, get),
        ...createServiceContractSlice(set, get)
      }),
      {
        name: 'equipment-store',
        partialize: state => ({
          activeStep: state.activeStep,
          selectedTransportType: state.selectedTransportType,
          selectedServiceContract: state.selectedServiceContract,
          dealerFitsChecked: state.dealerFitsChecked,
          factoryFitsChecked: state.factoryFitsChecked,
          selectedDealerOptions: state.selectedDealerOptions,
          archivedFactoryFits: state.archivedFactoryFits
        })
      }
    )
  )
)
